import React from 'react';
import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { PDF_TEXTS } from '../utils/texts';
import { SideBarCSS } from '../styles/style';

/**
 * NoSectionsPlaceholder component
 *
 * Displays a professional message with instructions when no PDF sections are selected for the report.
 * This serves as an empty state for the PDF preview canvas, preventing a blank UI.
 *
 * @component
 */
export const NoSectionsPlaceholder: React.FC = () => {
  return (
    <Box sx={SideBarCSS.placeholderBox}>
      <InfoOutlinedIcon sx={SideBarCSS.placeholderIcon} />
      <Typography variant="h5" sx={SideBarCSS.placeholderTitle}>
        {PDF_TEXTS.preview.noSections.title}
      </Typography>
      <Typography variant="body1" sx={SideBarCSS.placeholderText}>
        {PDF_TEXTS.preview.noSections.message}
      </Typography>
    </Box>
  );
};

